var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadsetGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12.5V9.16667C3.33301 5.945 5.945 3.33333 9.16634 3.33333H10.833C14.0547 3.33333 16.6663 5.945 16.6663 9.16667V12.5",
    stroke: "#4A5565",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 12.5C16.6667 11.5795 15.9205 10.8333 15 10.8333C14.0795 10.8333 13.3333 11.5795 13.3333 12.5V15C13.3333 15.9205 14.0795 16.6667 15 16.6667C15.9205 16.6667 16.6667 15.9205 16.6667 15V12.5Z",
    stroke: "#4A5565",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12.5C3.33333 11.5795 4.07953 10.8333 5 10.8333C5.92047 10.8333 6.66667 11.5795 6.66667 12.5V15C6.66667 15.9205 5.92047 16.6667 5 16.6667C4.07953 16.6667 3.33333 15.9205 3.33333 15V12.5Z",
    stroke: "#4A5565",
    strokeWidth: 1.66559,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetGray);
export default __webpack_public_path__ + "static/media/headsetGray.a968603c7116b5c97d57891944da3f5b.svg";
export { ForwardRef as ReactComponent };